import { render } from "./TheRoleBlocker.vue?vue&type=template&id=e5fcd016&scoped=true"
import script from "./TheRoleBlocker.vue?vue&type=script&lang=js"
export * from "./TheRoleBlocker.vue?vue&type=script&lang=js"

import "./TheRoleBlocker.vue?vue&type=style&index=0&id=e5fcd016&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5fcd016"]])

export default __exports__